import type { StorageStrategy } from "./StorageStrategy"

/**
 * Storage strategy backed by `window.sessionStorage`.
 * Data persists for the lifetime of the browser tab.
 *
 * Exported as a module-level singleton since it is stateless.
 */
class SessionStorageStrategy implements StorageStrategy {
  getItem(key: string): string | undefined {
    return window.sessionStorage.getItem(key) ?? undefined
  }

  setItem(key: string, value: string): void {
    window.sessionStorage.setItem(key, value)
  }

  deleteItem(key: string): void {
    window.sessionStorage.removeItem(key)
  }
}

export const sessionStorageStrategy = new SessionStorageStrategy()
